module.exports = __webpack_public_path__ + "static/media/Manual.2adbae0c.pdf";